import { Component, ViewEncapsulation, Input } from '@angular/core';
import { IconMapper } from '../../helpers/icon-mapper';

@Component({
       selector: 'cfa-cart-button',
    templateUrl: './cart-button.html',
    styleUrls: ['../../../styles/styles.scss', './cart-button.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CfaCartButton extends IconMapper {

    @Input() showCartTotal = false;
    @Input() showCartBadge = false;
    @Input() loading = false;
    @Input() cartBadgeNumber = 0;
    @Input() cartTotal = 0;
    @Input() icon = 'Bag';

    newCartBadgeNumber = false;


    constructor() {
        super();
    }

    /**
     * Sets the number to display in the cart badge. Also sets the cart to enabled.
     * @param count  The number to show in the cart badge
     */
    public setCartBadgeCount(count: number) {
        this.cartBadgeNumber = count;
        this.newCartBadgeNumber = true;
        setTimeout(() => {
            this.newCartBadgeNumber = false;
        }, 2000);
    }

    /**
     * Sets the number to display for the cart total. Also sets the cart to enabled.
     * @param total  The number to show for the cart total
     */
    public setCartTotal(total: number) {
        this.cartTotal = total;
    }

}
